// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  mobTypeId: __t.u32().name("mob_type_id"),
  entityType: __t.string().name("entity_type"),
  displayName: __t.string().name("display_name"),
  tagsJson: __t.string().name("tags_json"),
  baseHp: __t.i32().name("base_hp"),
  baseMana: __t.i32().name("base_mana"),
  moveDistance: __t.i32().name("move_distance"),
  viewRadius: __t.u32().name("view_radius"),
  speed: __t.u32(),
});
